import { Navigate } from "react-router-dom";
import useLoginCheck from "../hooks/useLoginCheck";

export default function PrivateRoute ({children, redirectOnFailure}) {
    const isLoggedIn = useLoginCheck();

    return isLoggedIn ? children : <Navigate to={redirectOnFailure} />
}